<template>
<div>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="8" md="4">
      <v-card class="elevation-8 pt-12 pb-12 pl-6 pr-6">
        <v-img height="120" contain src="../assets/Pelican_LogoB.png"></v-img>
        <v-card-title v-text="card.cardTitle" class="font-weight-black justify-center"></v-card-title>
        <v-card-subtitle v-text="card.cardSubTitle" class="font-weight-black text-center mt-0"></v-card-subtitle>
        <br />
        <center>
        <b>
          <font face="微軟正黑體" size="6" color="#FF5252">若需要做其他動作</font><br />
          <font face="微軟正黑體" size="6" color="#FF5252">請重新掃描QRcode</font><br />
        </b>
      </center>
      </v-card>
    </v-col>
  </v-row>
</div>
</template>

<script>
export default {
  data() {
    return {
      card: {
        cardTitle: "",
        cardSubTitle: "",
      },
    };
  },
}
</script>
